var defaultProps = {
  className: '',
  clearable: false,
  clearOnSearch: false,
  containerProps: {},
  disableButton: false,
  disabled: false,
  innerRef: undefined,
  onBlur: function onBlur() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onKeyUp: function onKeyUp() {
    return null;
  },
  onSearch: function onSearch() {
    return null;
  },
  onSearchButtonClick: function onSearchButtonClick() {
    return null;
  },
  placeholder: 'Search all',
  property: 'all',
  readOnly: false,
  searchOnEnter: true,
  showIcon: true,
  style: {},
  value: undefined
};
var navSearchBoxDefaultProps = {
  placeholder: 'Search...',
  currentResultIndex: -1
};

export { defaultProps, navSearchBoxDefaultProps };
//# sourceMappingURL=defaultProps.js.map
